import * as React from "react";

import UsersListing from "components/cards/users-listing";

// Icons
import { PageContext } from "components/layout/page-context";
import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";

const UsersIndexPage: React.FunctionComponent = () => {
  const page = useContext(PageContext);

  useEffect(() => {
    page.setTitle("Manage Users");
    page.setBackLink();
    page.setShowsClientSwitcher(false);
  });

  return (
    <section className="c-block c-block--spacing-b-small">
      <div className="o-container-fluid o-container--full">
        <div className="c-page-title">
          <h2 className="c-title--large">All users</h2>
          <Link
            to="/users/new"
            className="c-button c-button--stroke c-button--secondary c-button--icon u-hidden@md"
          ></Link>
          <Link
            to="/users/new"
            className="c-button c-button--stroke c-button--secondary u-hidden u-block@md"
          >
            <span>Add new user</span>
          </Link>
        </div>
        <UsersListing showAllUsers={true} clientId={"-1"} />
      </div>
    </section>
  );
};

export default UsersIndexPage;
